import { cn } from '@navinc/base-react-components'

import { resolveHrefFragment } from '@/app/lib/resolveHref.js'

import { FragmentType, getFragmentData } from '../../lib/cms/index.js'
import { CMSLink, cmsLinkWithMetaFragment } from '../Link/index.jsx'

export type ResourceCardProps = {
  title?: string
  caption?: string
  mediaUrl?: string | null
  alt?: string
  description?: string
  link?: (FragmentType<typeof cmsLinkWithMetaFragment> & FragmentType<typeof resolveHrefFragment>) | null
  invertBackground?: boolean
  cardSize?: 'wide' | 'standard' | 'condensed' | null
}

export const ResourceCard = ({
  title,
  caption,
  mediaUrl,
  alt,
  description,
  link,
  invertBackground,
  cardSize = 'standard',
}: ResourceCardProps) => {
  const linkData = getFragmentData(cmsLinkWithMetaFragment, link)
  return (
    <div
      className={cn(
        'flex flex-1 flex-col gap-300',
        invertBackground ? 'text-inverseOnSurface' : 'text-onSurfaceVariant',
      )}
    >
      {mediaUrl && (
        <div
          className={cn('w-full overflow-hidden rounded-200', cardSize === 'wide' ? 'aspect-[16/9]' : 'aspect-[4/3]')}
        >
          <img src={mediaUrl} alt={alt} className="size-full object-cover" />
        </div>
      )}
      <div className="flex flex-col gap-75 self-stretch">
        {title && <h3 className="headline font-semibold">{title}</h3>}
        {description && (
          <div className="mt-100">
            {description
              .split('\n')
              .map((line, i) => {
                const text = line.trim()
                if (!text) {
                  return <br key={i} />
                }
                return (
                  <p key={i} className="body1">
                    {text}
                  </p>
                )
              })
              .filter(Boolean)}
          </div>
        )}
        {caption && <p className="caption1">{caption}</p>}
        {linkData && (
          <div className="mt-100">
            <CMSLink {...linkData} density="tight" className="w-full md:w-auto">
              {linkData.label}
            </CMSLink>
          </div>
        )}
      </div>
    </div>
  )
}
